import { Request } from "./HttpService";
import { translateAndSortAscendant } from "../common/helper";

export const AvailabilityService = {
  getAvailabilityStatus: function () {
    return Request("vitae/availability", "GET").then((data)=>{
      return translateAndSortAscendant (data, "description");
    });;
  },
  getAvailabilityStatusByCode: function (code) {
    return Request(`vitae/availability/getAvailabilityByCode/${code}`, "GET");
  }
};
